import * as Yup from 'yup';

/**
 * Extends Yup with new methods
 */
/**
 * Validate if a string contains invalid characters
 */
Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'validCharacters',
  function test(errorMessage = 'Invalid Characters') {
    return this.test(
      'validCharacters',
      errorMessage,
      (value: string | undefined): boolean => {
        return !/[`!@#$%^*()_+\-=\\[\]{};':"\\|,.<>/?~]/.test(value || '');
      }
    );
  }
);
Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'validPaSCharacters',
  function test(errorMessage = 'Invalid Characters') {
    return this.test(
      'validPaSCharacters',
      errorMessage,
      (value: string | undefined): boolean => {
        return !/[`!@#$%^*()_+\-=\\[\];':"\\,.<>/?~]/.test(value || '');
      }
    );
  }
);

export default Yup;
